import * as antlr4 from 'antlr4';
export const Token = antlr4.Token;
;
;
export function intervalSetOf(a, b) {
    let s = new antlr4.IntervalSet();
    s.addInterval(new antlr4.Interval(a, b));
    return s;
}
export function intervalSetToArray(set) {
    const values = [];
    const n = set.intervals.length;
    for (let i = 0; i < n; i++) {
        const interval = set.intervals[i];
        const a = interval.start;
        const b = interval.stop;
        for (let v = a; v < b; v++) {
            values.push(v);
        }
    }
    return values;
}
//# sourceMappingURL=antlr4.js.map